export const percentageOf = (value, total) => {
  const calculation = ((value / total) * 100).toFixed(2);

  return parseFloat(calculation);
};

export default percentageOf;
